


































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import InsertWidgetModal from '../insert-new-widget-modal/insert-widget-modal.vue';
import { cscApiService } from '@/shared/api-service/csc-api-service';
import { Mutation, namespace, State } from 'vuex-class';
import { CoreStoreState } from '../../../core/core.store';
import { UnifiedInsightsStoreState } from '../unified-insights.store';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { unifiedMessageContainer } from '../../../shared/constants';
import { nsmApiService } from '@/shared/api-service/nsm-api-service';
import SaveConfigurartionsModal from './../save-configurations-modal/save-configurations-modal.vue';
import {
  messageService,
  SwMessageContainer,
} from '@libs-uuif/shared/message-service';
import { RootStoreState } from '@/store';
import { DropdownLight } from '@/shared/dropdown-light';
import { Base64 } from 'js-base64';

const cssPrefix = 'dashboard-header';
const unifiedInsightsStoreModule = namespace('UnifiedInsightsStoreModule');

@Component({
  components: {
    InsertWidgetModal,
    SwMessageContainer,
    SwIcon,
    DropdownLight,
    SaveConfigurartionsModal,
  },
})
export default class DashboardHeader extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @State((state: RootStoreState) => state.CoreStoreModule.tenant)
  tenant: CoreStoreState['tenant'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantName)
  tenantName: CoreStoreState['tenantName'];

  @State((state: RootStoreState) => state.CoreStoreModule.userList)
  userList: CoreStoreState['userList'];

  @State((state: RootStoreState) => state.CoreStoreModule.reloadWidgets)
  reloadWidgets: CoreStoreState['reloadWidgets'];

  @unifiedInsightsStoreModule.State
  widgets: UnifiedInsightsStoreState['widgets'];

  @unifiedInsightsStoreModule.State
  disableSaveDashboardLayout: UnifiedInsightsStoreState['disableSaveDashboardLayout'];

  @unifiedInsightsStoreModule.Mutation
  setDisableSaveDashboardLayout: VuexMappedMutation<
    UnifiedInsightsStoreState['disableSaveDashboardLayout']
  >;

  @unifiedInsightsStoreModule.Mutation
  setSavedDashboardLayout: VuexMappedMutation<
    UnifiedInsightsStoreState['savedDashboardLayout']
  >;

  @unifiedInsightsStoreModule.Mutation
  setSelectedUserInDashboard: VuexMappedMutation<
    UnifiedInsightsStoreState['selectedUserInDashboard']
  >;

  @Mutation
  setReloadWidgets: VuexMappedMutation<CoreStoreState['reloadWidgets']>;

  @Mutation
  setTenantGroups: VuexMappedMutation<CoreStoreState['tenantGroups']>;

  @State((state: RootStoreState) => state.CoreStoreModule.productList)
  readonly productList: CoreStoreState['productList'];

  @State((state: RootStoreState) => state.UnifiedInsightsStoreModule.isReadOnlyUser)
  readonly isReadOnlyUser: UnifiedInsightsStoreState['isReadOnlyUser'];

  @unifiedInsightsStoreModule.State
  selectedUserInDashboard: UnifiedInsightsStoreState['selectedUserInDashboard'];

  showInsertWidgetModal: boolean = false;
  isSaveInProgress: boolean = false;
  autoHide: boolean = true;
  isPageRefresh: boolean = true;
  showSaveWidgetConfigurations: boolean = false;

  setDashboard(e : any) {
    this.setSelectedUserInDashboard(e);
  }

  /**
   * @desc Will be called when the user clicks on insert widget modal
   */
  insertWidget() {
    if (this.isReadOnlyUser) {
      return;
    }
    this.showInsertWidgetModal = true;
    document.body.style.height = '100%';
    document.body.style.overflowY = 'hidden';
  }

  /**
   * @desc Will be called the user clicks on the save or cancel button of insert widget modal
   */
  onCloseModal() {
    this.showInsertWidgetModal = false;
    document.body.style.height = '';
    document.body.style.overflowY = '';
  }

  /**
   * @desc To emit the widget added event to parent component
   */
  widgetAdded() {
    this.$emit('widgetAdded');
  }

  /**
   * @desc Save the layout of the dashboard
   */
  saveWidgetConfigurations() {
    if (this.disableSaveDashboardLayout || this.isReadOnlyUser) {
      return;
    }
    this.showSaveWidgetConfigurations = true;
  }

  refreshPage() {
    if (this.productList.includes('NGMGMT')) {
      this.setNsmGroups();
    }
    this.$emit('pageRefreshed', this.isPageRefresh);
    this.isPageRefresh = !this.isPageRefresh;
  }

  exportToPdf() {
    this.$emit('export-to-pdf');
  }
  /**
   * @desc Delete the layout of the dashboard
   */
  restoreDashboard() {
    this.$emit('restore-dashboard');
    this.isSaveInProgress = true;
    cscApiService
      .deleteDashboardLayout({ tenantId: this.tenant,
        widgetData: '',
      })
      .then((response: any) => {
        if (response.operationStatus !== 'OK') {
          throw new Error(response.msgDesc);
        }
        this.setDisableSaveDashboardLayout(true);
        this.setSavedDashboardLayout(this.widgets);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.dashLayoutSucc')
          .toString(),
          'success',
        );
        this.setReloadWidgets(!this.reloadWidgets);
      })
      .catch((error: any) => {
        this.setDisableSaveDashboardLayout(false);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.dashLayoutFail')
          .toString(),
          'failed',
        );
        console.error('Dashboard layout fetch API error ', error);
      })
      .finally(() => (this.isSaveInProgress = false));
  }
  onSaveDashboard(response: { mode: string; }) {
    this.showSaveWidgetConfigurations = false;
    if (response &&
      response.hasOwnProperty('mode') &&
      response.mode !== 'CLOSED') {
      this.isSaveInProgress = true;
      const mode = response.mode ? response.mode : 'SAVE';
      cscApiService
      .saveDashboardLayout(
        mode,
        {
          tenantId: this.tenant,
          widgetData: Base64.encode(JSON.stringify(this.widgets)),
        },
      )
      .then((response: any) => {
        if (response.operationStatus !== 'OK') {
          throw new Error(response.msgDesc);
        }
        this.setDisableSaveDashboardLayout(true);
        this.setSavedDashboardLayout(this.widgets);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.dashLayoutSucc')
          .toString(),
          'success',
        );
      })
      .catch((error: any) => {
        this.setDisableSaveDashboardLayout(false);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.dashLayoutFail')
          .toString(),
          'failed',
        );
        console.error('Dashboard layout fetch API error ', error);
      })
      .finally(() => (this.isSaveInProgress = false));
    }
  }
  setNsmGroups() {
    nsmApiService
      .getTenantGroups()
      .then((response) => {
        const groupsData = response.map((group: any) => {
          if (group.groupID && group.friendlyName) {
            let innerGroupDevices: any = [];
            if (group.deviceGroups) {
              innerGroupDevices = this.fetchInnerDevices(
                response,
                group.deviceGroups,
                [group.groupID],
              );
            }
            const groupDevices = group.devices ? group.devices : [];
            return {
              groupId: group.groupID,
              groupName: group.friendlyName,
              devices: [...groupDevices, ...innerGroupDevices] || [],
            };
          }
        });
        this.setTenantGroups(groupsData);
      })
      .catch((error) => {
        this.setTenantGroups([]);
        console.error('NSM fetch tenant groups API error', error);
      });
  }
  /**
   * @desc This function is used to fetch the devices in the inner groups
   * @param groupsData Reponse groups data
   * @param innerGroups inner Groups
   * @param visitedGroup visited groups
   */
  fetchInnerDevices(groupsData: any, innerGroups: any, visitedGroup: any) {
    if (!innerGroups) {
      return [];
    }
    let innerGroupDevices: any = [];
    innerGroups.map((innerGroupId: any) => {
      if (visitedGroup.includes(innerGroupId)) {
        return;
      }
      const innerGroup = groupsData.find(
        (responseGroup: any) => responseGroup.groupID === innerGroupId,
      );
      innerGroup &&
        innerGroup.devices &&
        (innerGroupDevices = [...innerGroupDevices, ...innerGroup.devices]);
      innerGroup &&
        innerGroup.deviceGroups &&
        (innerGroupDevices = [
          ...innerGroupDevices,
          ...this.fetchInnerDevices(groupsData, innerGroup.deviceGroups, [...visitedGroup, innerGroupId]),
        ]);
    });
    return innerGroupDevices;
  }
}
